export class LevelOfDetailDTO {
  constructor(readonly scale: number, readonly geojsonUrl: string) {}
}
